/**
 * Zuschnitt dieser Bereitstellung.
 *
 * Bis zum 19.08.2026 trug eine Instanz alle Mandanten und der Kopf bot einen
 * Umschalter an. Für den Kunden gilt das Gegenteil: **eine Bereitstellung,
 * ein Mandant.** Eigene Datenbank, eigene Entra-Registrierung, eigenes
 * Protokoll — und deshalb auch nichts, wohin ein Umschalter führen könnte.
 *
 * `VITE_MANDANT` wird beim Bau gesetzt (Dockerfile → Build-Argument, gefüllt
 * aus der Bereitstellung). Fehlt der Wert, bleibt alles wie bisher: die
 * Instanz führt mehrere Mandanten und die Wahl steht im Kopf.
 *
 * Der Wert ist **kein Geheimnis und keine Absicherung**. Er entscheidet nur,
 * was die Oberfläche anbietet. Die Grenze zieht die API: `MANDANTEN` nennt
 * dort die Mandanten dieser Instanz, und ein Kopf `X-Mandant` mit einem
 * anderen Code wird abgewiesen — nicht ausgeblendet, abgewiesen.
 */

const roh = (import.meta.env['VITE_MANDANT'] ?? '').trim().toLowerCase();

/**
 * Der festgelegte Mandantenschlüssel dieser Instanz, oder `null`, wenn die
 * Instanz mehrere führt. Schlüssel, nicht Name: `howoge`, nicht `HOWOGE` —
 * er zeigt auf einen Eintrag in `PROFILE`.
 */
export const INSTANZ_MANDANT: string | null = roh === '' ? null : roh;

/** Darf im Kopf zwischen Mandanten gewechselt werden? */
export const MANDANT_WAEHLBAR: boolean = INSTANZ_MANDANT === null;
